import axios from "axios";
import { environment } from "../../../environments/environment";



export function getPartRequestList(page = 0, pageSize = 10, sortingOrder, search, filters, type = "") {
  let filterArray = [];
  
  filterArray.push({
    columnName: "company_id",
    value: [parseInt(localStorage.getItem("u_company_id"))],
  });
  return axios.post(
    `${environment.getPartRequestList}?page=${page}&pageSize=${pageSize}&search=${search}&orderBy=${sortingOrder}&type=${type}`,
    filterArray,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
}
export const getPartRequestListHierarchycal = (page = 0, pageSize = 10, sortingOrder, search, filters , type) => {
  let params = new URLSearchParams();
  params.append("page", page);
  params.append("pageSize", pageSize);
  params.append("orderBy", sortingOrder);
  params.append("search", search);
  params.append("type" , type)
  // if(filters) {
  //  filters.push({
  //     columnName: "accountId",
  //     value: [parseInt(localStorage.getItem("u_account_id"))],
  //   });
  // }
  return axios.post(environment.getPartRequestList + "?" + params, filters)
}

export function getPartRequestTabularInfo(page = 0, pageSize = 10, sortingOrder, search, partReqId) {
  let filterArray = [];
  filterArray.push({
    columnName: "company_id",
    value: [parseInt(localStorage.getItem("u_company_id"))],
  });
  return axios.post(
    `${environment.getPartRequestTabularInfo}?page=${page}&pageSize=${pageSize}&search=${search}&orderBy=${sortingOrder}&reqId=${partReqId}`,
    filterArray,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
}

export const issuePartsFromPartRequest = (body) => {
  return axios.post(environment.issuePartsFromPartRequest, body)
}
export const partReturn = (body) => {
  return axios.post(environment.partReturn, body)
}
export const createPartRequestAndIssue = (body) => {
  return axios.post(environment.createPartRequestAndIssue, body)
}

export const createPartRequest = (body) => {
  return axios.post(environment.createPartRequest, body)
}

export const savePartRequest = (body) => {
  return axios.put(environment.savePartRequest, body)
}

export const deletePartRequest = (id) => {
  let params = new URLSearchParams();
  params.append("partRequestId", id);
  return axios.delete(environment.deletePartRequest + params)
}


export const getPRNListDetails = (page, pageSize, orderBy, search, body) => {
  let param = new URLSearchParams()
  param.append("page", page);
  param.append("pageSize", pageSize);
  param.append("orderBy", orderBy);
  param.append("search", search);

  return axios.post(environment.getPRNListDetails + param, body)
}

export const getPRNEditionForm = (PRNId) => {
  let param = new URLSearchParams();
  param.append("partRequestId", PRNId);

  return axios.get(environment.getPRNEditionForm + param)
}

export const getEmployeesByLocation = (locationId) => {
  let param = new URLSearchParams();
  param.append("locationId", locationId);

  return axios.get(environment.getEmployeesByLocation + param);
}
export const getSerializedPRNParts = (part_id, company_id, location_id) => {
  let params = new URLSearchParams();
  params.append("partId", part_id);
  params.append("companyId", company_id);
  params.append("locationId", location_id)

  return axios.get(environment.getSerializedPartsToPRNparts + params)
}

export const getBatchesToPRN = (part_id, company_id, location_id) => {
  let params = new URLSearchParams();
  params.append("partId", part_id);
  params.append("companyId", company_id);
  params.append("locationId", location_id)

  return axios.get(environment.getBatchToPRNParts + params)
}


export const deletePartRequestDetailPart = (partRequestDetailId) => {
  let param = new URLSearchParams();
  param.append("id", partRequestDetailId);
  return axios.delete(environment.deletePartRequestDetailPart + param)
}

export const updatePartRequestDetailPart = (body) => {
  return axios.put(environment.updatePartRequestDetailPart, body)
}